import _styled from "@emotion/styled/base";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Notice, Stack } from '../../../../../../../primitives/index.js';
export const Information = /*#__PURE__*/_styled(({
  children,
  ...restProps
}) => {
  return _jsx(Stack, {
    ...restProps,
    direction: "row",
    alignItems: "center",
    children: _jsx(Notice, {
      variant: "info",
      children: children
    })
  });
}, process.env.NODE_ENV === "production" ? {
  target: "e24iix00"
} : {
  target: "e24iix00",
  label: "Information"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImluZGV4LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUtHIiwiZmlsZSI6ImluZGV4LmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsganN4IGFzIF9qc3ggfSBmcm9tIFwiQGVtb3Rpb24vcmVhY3QvanN4LXJ1bnRpbWVcIjtcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCB7IE5vdGljZSwgU3RhY2sgfSBmcm9tICcuLi8uLi8uLi8uLi8uLi8uLi8uLi9wcmltaXRpdmVzL2luZGV4LmpzJztcbmV4cG9ydCBjb25zdCBJbmZvcm1hdGlvbiA9IHN0eWxlZCgoeyBjaGlsZHJlbiwgLi4ucmVzdFByb3BzIH0pID0+IHtcbiAgICByZXR1cm4gKF9qc3goU3RhY2ssIHsgLi4ucmVzdFByb3BzLCBkaXJlY3Rpb246IFwicm93XCIsIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsIGNoaWxkcmVuOiBfanN4KE5vdGljZSwgeyB2YXJpYW50OiBcImluZm9cIiwgY2hpbGRyZW46IGNoaWxkcmVuIH0pIH0pKTtcbn0pIGBgO1xuLy8jIHNvdXJjZU1hcHBpbmdVUkw9aW5kZXguanMubWFwIl19 */");